/* eslint-disable no-unused-vars */
import React from 'react';

const Edit = (props) => {
  return '***This section will look like an empty line!***';
};

export default Edit;
